import { Component, OnInit } from '@angular/core';
import { GeneralserviceService } from '../../services/generalservice.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ToastrService, GlobalConfig } from 'ngx-toastr';
declare var $

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {

  Tabelname: string;
  CategoryStatus: any;
  CategoryId: any;
  id: any;
  Id: any;
  ServiceCategoryCode: any;
  ServiceCategory: string;
  image: any;
  imagefile: any;
  ProductImagePdfPath: any;
  msg: string;
  ImageArray: any[];
  Flag: any;
  ButtonText: string;
  Category: any;
  HomeURL: any;
  cols: { field: string; header: string; width: string; }[];
  gridview: boolean = false;
  CategoryImage: any;
  ImageData: any;
  //flag: any;
  ServiceCategoryId: any;
  Description: any;
  Image: any;
  Status: any;



  constructor(public generalservice: GeneralserviceService, public http: HttpClient, public router: Router) {
    if (localStorage.getItem("LoginDetails") == null) {
      this.router.navigate(['/login']);
    }
    this.http.get('../assets/WebService.json').subscribe((data: any) => {
      debugger
      this.HomeURL = data.Webservice;
    });

    this.cols = [

      // { field: 'ServiceCategoryId', header: '#', width: '80px' },
      { field: 'ServiceCategory', header: 'Service Category', width: '100px' },
      { field: 'ServiceCategoryCode', header: 'Service Category Code', width: '110px' },
      { field: 'Description', header: 'Description', width: '150px' },
      // { field: 'Status', header: 'Status', width: '100px' },
      // { field: 'Image', header: 'Image', width: '200px' },
    ];
  }

  ngOnInit() {
    this.GetCategory();
  }
  GetCategory() {
    var url = 'api/Values/Get_CategoryGrid';
    this.generalservice.GetData(url).then((data: any) => {
      debugger
      this.Category = data;
      //console.log(this.Category);
    }, err => {
      this.generalservice.ShowAlert('ERROR', 'Something went wrong. Please try again later.', 'error')
      //this.spinner = false;
    });
  }

  ViewImage(rowData) {
    debugger
    //this.spinner.show();

    ServiceCategoryId: this.ServiceCategoryId,
      this.ServiceCategoryId = rowData.ServiceCategoryId

    var FormDat = new FormData();
    FormDat.append("ServiceCategoryId", this.ServiceCategoryId);
    var url = "/api/Values/Get_categoryimage";
    this.generalservice.PostData(url, FormDat).then((data: any) => {
      debugger
      this.Image = data;
      //this.image = this.HomeURL + data;

      debugger
      if (data.length != 0) {
        debugger
        this.Image = data;
        //this.spinner.hide();
        $('#NmyModal').modal('show');
      }

      else {
        //$('#NmyModal').modal('hide');

        //this.spinner.hide();
        this.generalservice.ShowAlert('INFO', 'No Data Found', 'info');
      }
    }, err => {
      //this.spinner.hide();
      this.generalservice.ShowAlert('ERROR', 'Something Went wrong', 'error');
    });
  }


  detectFiles(input) {
    debugger
    const reader = new FileReader();
    if (input.files.length) {
      debugger
      const file = input.files[0];
      this.ProductImagePdfPath = input.files[0];
      reader.onload = () => {
        debugger
        this.imagefile = reader.result;
        this.image = this.imagefile;
      }
      reader.readAsDataURL(file);
      var selectedFile = file;
      var idxDot = selectedFile.name.lastIndexOf(".") + 1;
      var extFile = selectedFile.name.substr(idxDot, selectedFile.name.length).toLowerCase();
      if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
        debugger
        var UploadFile = new FormData();
        UploadFile.append("PostedFile", file);
        var url = 'api/Values/uploadImage';
        this.generalservice.PostData(url, UploadFile).then((data: any) => {
          if (data != null) {
            debugger
            this.imagefile = this.HomeURL + data;
            this.image = data;
          }
        });
      }
      else {
        alert("Only jpg/jpeg, png files are allowed!");
      }

    }
  }

  fileChange(event) {
    debugger
    //let fileList = event.target.files;
    let fileList = event.target.files;

    if (fileList.length > 0) {
      const frmData = new FormData();
      for (var i = 0; i < fileList.length; i++) {
        frmData.append("PostedFile", fileList[i]);
      }
      var url = 'api/Values/uploadImage';
      this.generalservice.PostData(url, frmData).then((data: any) => {
        if (data != null) {
          debugger
          this.ImageData = data;
          for (var i = 0; i < this.ImageData.length; i++) {
            debugger
            this.ImageArray.push({ ProductImage: this.ImageData[i] })
            //this.Imagelist += "<Images><Image>" + this.ImageData[i] + "</Image></Images>"
          }
        }
      });
    }



  }

  AddCategory(ServiceCategory, ServiceCategoryCode) {
    debugger
    if (ServiceCategory == "" || ServiceCategoryCode == "") {
      this.generalservice.ShowAlert("WARNING", "Please Fill The All The Required", "warning");
    }
    else {
      let arr = [];
      arr.push({
        ServiceCategory: this.ServiceCategory
        , Image: this.image
        , ServiceCategoryCode: this.ServiceCategoryCode
        , Description: this.Description
        , ServiceCategoryId: this.Id
        , Status: true
      })
      var UploadFile = new FormData();
      UploadFile.append("CategoryDetails", JSON.stringify(arr));
      UploadFile.append("Flag", this.Flag);

      var url = 'api/Values/Add_update_delete_category';
      this.generalservice.PostData(url, UploadFile).then((data: any) => {
        //  var url = "api/Values/Add_update_delete_category?ServiceCategory=" + ServiceCategory + "&Image=" + this.image + "&ServiceCategoryCode=" + ServiceCategoryCode;
        //   this.generalservice.GetData(url).then((data: any) => {
        debugger
        if (data == 'SUCCESS') {
          if (this.Flag == 1) {
            this.generalservice.ShowAlert("SUCCESS", "Category added successfully", "success");
          }
          else {
            this.generalservice.ShowAlert("SUCCESS", "Category updated successfully", "success");

          }
          this.GetCategory();
          this.Back();
        }
        else {
          this.generalservice.ShowAlert("WARNING", "Something went wrong please try agin", "warning");
        }
      })

    }

  }
  ShowAlert(title: any, text: any, type: any) {
    Swal.fire({
      title: title,
      html: text,
      confirmButtonText: 'Ok'
    })
  }



  /*update active and dactivate status on categories*/
  UpdateStatus(ev, rowData) {
    debugger
    // var url = "api/Values/Add_update_delete_category?ServiceCategory=" + ServiceCategory + "&Image=" + this.image + "&ServiceCategoryCode=" + ServiceCategoryCode;
    this.ServiceCategoryId = rowData.ServiceCategoryId;
    this.CategoryStatus = ev.checked;

    let arr = [];
    arr.push({
      ServiceCategoryId: this.ServiceCategoryId
      , Status: this.CategoryStatus
    })
    var UploadFile = new FormData();
    UploadFile.append("CategoryDetails", JSON.stringify(arr));
    UploadFile.append("Flag", '3');

    var url = 'api/Values/Add_update_delete_category';
    this.generalservice.PostData(url, UploadFile).then((data: any) => {
      //this.generalservice.GetData(url).then((data: any) => {
      debugger;
      if (data == 'SUCCESS') {
        this.generalservice.ShowAlert("SUCCESS", "Category Status Updated Successfully", "success");
      }
    });
  }
  /*end code*/

  Edit(rowData) {
    debugger
    this.gridview = true;
    this.ButtonText = "Update";
    this.Flag = 2;
    this.Id = rowData.ServiceCategoryId;
    this.ServiceCategory = rowData.ServiceCategory;
    this.ServiceCategoryCode = rowData.ServiceCategoryCode;
    this.Description = rowData.Description
    this.image = rowData.Image;
    this.imagefile = this.HomeURL + rowData.Image;
  }

  openAddForm() {
    this.Clear();
    this.gridview = true;
    this.ButtonText = "Add";
    this.Flag = 1;
    this.image = '';
    this.msg = "Category Added Successfully";
    this.ServiceCategory = "";
    this.ServiceCategoryCode = "";
  }
  Clear() {
    this.image = "",


      this.ServiceCategory = null,
      this.Description = null,
      this.ServiceCategoryCode = null

  }
  Back() {
    this.gridview = false;
  }
  //Reset() {
  //  this.ServiceCategoryId = null;
  //  this.ServiceCategory = '';
  //  this.Description = '';
  //  this.ServiceCategoryCode = '';
  //  this.Image = null;
  //  this.Status = null;

  //}
}
//new
